import React from 'react';
import styles from './ActorCard.module.css';
import ActorCardMeta from './ActorCardMeta';
import Badge from '../Badge/Badge';

/**
 * @component ActorCardInfo
 * @description 이름 + 메타(성별·나이·키) + 스킬 태그
 *
 * @param {string}   props.name    - 배우 이름
 * @param {string}   props.gender  - 성별
 * @param {number}   props.age     - 나이
 * @param {number}   props.height  - 키
 * @param {string[]} props.skills  - 보유 기술 배열
 */
function ActorCardInfo({ name, gender, age, height, skills }) {
  return (
    <div className={styles.info}>
      <h3 className={styles.name}>{name}</h3>
      <ActorCardMeta gender={gender} age={age} height={height} />
      {skills && skills.length > 0 && (
        <div className={styles.skillTags}>
          {skills.map((skill) => (
            <Badge key={skill} variant="accent" size="small">
              {skill}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}

export default ActorCardInfo;
